/*
* Broadcast Theme - custom.js
* ---------------------------------------------------------------------------
* MISS SWIG. Two small site-wide behaviours:
*   1. the SALE seal on cards Liquid has flagged as a genuine sale
*   2. "#buy" links that scroll to the buy button instead of navigating
* ---------------------------------------------------------------------------
*/

/* ===========================================================================
   1. SALE SEAL
   ---------------------------------------------------------------------------
   This file used to rewrite the text of every .msfc-pill from a hardcoded
   list of product handles, which meant badge wording was decided in
   JavaScript after render and silently overrode the Liquid. All of that now
   lives in snippets/ms-card-pill.liquid, which works the percentage out from
   real prices and honours the _sale and _preorder tags.

   This only decorates: it adds the seal to things Liquid has already marked
   data-ms-sale="1". Liquid decides, JavaScript decorates. Never the reverse.

   NOTE ON THE PRODUCT PAGE GATE: this used to seal the gallery whenever ANY
   .ms-deal-badge was on the page, which meant a set showing nothing but its
   "Bundle - Save $12" pill got stamped SALE. A bundle price is not a
   discount, so the gate now requires the sale marker specifically. The two
   selectors below are the whole contract - if a badge is not marked
   data-ms-sale="1" in Liquid, no seal appears anywhere.
   =========================================================================== */
(function () {
  var SEAL_SVG =
    '<svg viewBox="0 0 100 100" width="100%" height="100%" style="display:block">' +
      '<path fill="#ff2e6a" d="M 50 12 A 10 10 0 0 1 64.5 14.9 A 10 10 0 0 1 76.9 23.1 A 10 10 0 0 1 85.1 35.5 A 10 10 0 0 1 88 50 A 10 10 0 0 1 85.1 64.5 A 10 10 0 0 1 76.9 76.9 A 10 10 0 0 1 64.5 85.1 A 10 10 0 0 1 50 88 A 10 10 0 0 1 35.5 85.1 A 10 10 0 0 1 23.1 76.9 A 10 10 0 0 1 14.9 64.5 A 10 10 0 0 1 12 50 A 10 10 0 0 1 14.9 35.5 A 10 10 0 0 1 23.1 23.1 A 10 10 0 0 1 35.5 14.9 A 10 10 0 0 1 50 12 Z"/>' +
      '<circle cx="50" cy="50" r="30" fill="none" stroke="#fff" stroke-opacity=".4" stroke-width="1.6"/>' +
      '<text x="50" y="57" text-anchor="middle" font-family="DM Sans,Arial,sans-serif" font-size="26" font-weight="800" fill="#fff" letter-spacing="1.5">SALE</text>' +
    '</svg>';

  function makeSeal(size) {
    var s = document.createElement('span');
    s.className = 'ms-sale-seal';
    s.setAttribute('aria-hidden', 'true');
    s.style.cssText = 'position:absolute;top:8px;right:8px;z-index:6;width:' + size + ';aspect-ratio:1;pointer-events:none;filter:drop-shadow(0 2px 5px rgba(0,0,0,.22));transform:rotate(-9deg);';
    s.innerHTML = SEAL_SVG;
    return s;
  }

  function sealCards(root) {
    (root || document).querySelectorAll('.msfc-pill[data-ms-sale="1"]').forEach(function (pill) {
      if (pill.dataset.msSealed) return;
      pill.dataset.msSealed = '1';

      var card = pill.closest('.msfc-card');
      var host = pill.closest('.msfc-media') || card;
      if (!host) return;
      if (card && card.hasAttribute('data-msrv-preorder')) return;
      if (host.querySelector('.ms-sale-seal')) return;

      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(makeSeal('clamp(44px,26%,58px)'));
    });
  }

  function sealProduct() {
    if (!document.querySelector('.ms-deal-badge[data-ms-sale="1"]')) return;
    var g = document.querySelector('product-images') || document.querySelector('.product__slides');
    if (!g || g.querySelector('.ms-sale-seal')) return;
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    g.appendChild(makeSeal('clamp(60px,11%,88px)'));
  }

  function run(root) {
    try { sealCards(root); } catch (e) {}
    try { sealProduct(); } catch (e) {}
  }

  if (document.readyState !== 'loading') run(document);
  document.addEventListener('DOMContentLoaded', function () { run(document); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();

/* ===========================================================================
   2. SCROLL TO THE BUY BUTTON
   ---------------------------------------------------------------------------
   Any link with href="#buy" scrolls up to the product form instead of
   navigating. Set a section's Button link field to  #buy  in the theme
   editor and it just works - no section code required, and it applies to any
   section added later.

   Behaviour:
     - offsets for the sticky header so the button is not hidden under it
     - briefly highlights the buy button on arrival, so it is obvious where
       you have been sent and why
     - moves keyboard focus to the button, so it works for keyboard and
       screen reader users rather than only visually
     - if there is no buy form on the page (e.g. the block is used on the
       homepage), falls back to the all-products collection rather than
       doing nothing
     - honours prefers-reduced-motion by jumping instead of gliding
   =========================================================================== */
(function () {
  var BUY_SELECTORS = [
    '[data-product-form]',
    'product-form',
    '.product__submit',
    '[data-add-to-cart]'
  ];

  function findBuy() {
    for (var i = 0; i < BUY_SELECTORS.length; i++) {
      var el = document.querySelector(BUY_SELECTORS[i]);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  function headerOffset() {
    var h = document.querySelector('.header, [data-header-height], header');
    var n = h ? h.getBoundingClientRect().height : 0;
    return Math.min(n, 120) + 18;
  }

  function flash(el) {
    var btn = el.querySelector('[data-add-to-cart], button[name="add"]') || el;
    if (!btn || btn.dataset.msFlashing) return;
    btn.dataset.msFlashing = '1';

    var prev = btn.style.boxShadow;
    var prevT = btn.style.transition;
    btn.style.transition = 'box-shadow .25s ease';
    btn.style.boxShadow = '0 0 0 4px rgba(240,128,91,.45)';

    setTimeout(function () {
      btn.style.boxShadow = prev;
      setTimeout(function () {
        btn.style.transition = prevT;
        delete btn.dataset.msFlashing;
      }, 300);
    }, 900);

    if (typeof btn.focus === 'function') {
      try { btn.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('a[href$="#buy"], a[href="#buy"]') : null;
    if (!link) return;

    var target = findBuy();
    if (!target) {
      /* nothing to scroll to on this page - send them somewhere useful */
      e.preventDefault();
      window.location.href = '/collections/all';
      return;
    }

    e.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();

    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    setTimeout(function () { flash(target); }, reduce ? 0 : 520);
  });
})();
